// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Z1-z","displaySixCardTiles":"_1-z"};